<template>

  <div class="content-wrapper ">

        <h4 class="print_hide card-title float-left"><span class="" style="font-weight: 300">{{$t('Group')}}: </span>{{group.name}}</h4>
        <div class="print_show p-4">
          <h2 class="text-center">{{filters.labelType != 'TEMPERATURE' ? $t(filters.labelType) : $t('Appliance Temperature')}}</h2>
          <div class="float-left">
          <h4 class="card-title">{{group.category}}</h4>
            <h3 class="card-title">{{group.name}}</h3>
          </div>
          <div class="float-right">
            <h4 v-show="startDateFormatted != null" class="card-title">{{$t("Start Date")}}: <span class="float-right pl-2">{{ startDateFormatted}}</span></h4>
            <h4 v-show="endDateFormatted != null" class="card-title">{{$t("End Date")}}: <span class="float-right pl-2">{{ endDateFormatted}}</span></h4>
          </div>
          <br><br>
        </div>
        <h4 class="print_hide" style="float:right"><span style="font-weight: 300">{{$t('Category')}}:</span>
          <b-link v-if="$store.state.user.data.role !== 'System Admin'" :append="true" style="display: inline;" :to="{path: `/company/${group.category}`}">{{group.category}} </b-link>
          <b-link v-else :append="true" style="display: inline;" :to="{path: `/companies/${$route.params.company}/category/${group.category}`}">{{group.category}} </b-link>
        </h4>
    <br><br>
        <b-tabs content-class="bg-white">
          <b-tab :title="$t('Labels')" id="labels">
            <b-container fluid class="no-padding">
              <!-- User Interface controls -->
              <div class="print_hide" style="background-color: #e8f4f9;padding: 15px;padding-bottom: 0;">
                <b-row>
                  <h4 class="pl-2">{{$t('Filters')}}</h4>
                  <b-col lg="12" class="my-1">
                    <b-form-group>
                      <b-form-radio-group
                        v-model="filters.labelType"
                        :options="labelTypes"
                        name="buttons-1"
                        buttons
                        button-variant="white"
                        @change="clearResults()"
                        :state="$v.filters.labelType.$dirty ? !$v.filters.labelType.$error : null"
                      >

                      </b-form-radio-group>
                      <div v-show="$v.filters.labelType.$error" class="text-danger"> {{$t('This is a required field.')}}</div>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row>
                <b-col lg="4" class="my-1">
                  <b-form-group
                    :label="$t('Select Users')"
                    label-for="name-input"
                  >
                    <multiselect v-model="filters.users" :groupSelect="true" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="usersOptions" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" group-label="groupName" group-values="users" :taggable="false" :preserve-search="false" :placeholder="$t('Select User')" label="text" track-by="value" :preselect-first="false">
                      <!--<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>-->
                    </multiselect>
                    <!--<b-form-select size="sm" v-model="filters.users" :options="usersOptions"></b-form-select>-->
                  </b-form-group>
                </b-col>
                <b-col lg="8" class="my-1">
                  <b-form-group
                    :label="$t('Date Range')"
                    label-for="name-input"
                  >
                    <v-date-picker
                      mode='range'
                      v-model="filters.dateRange"
                      show-caps
                      :max-date='new Date()'
                    >
                    </v-date-picker>
                    <button
                      type="button"
                      class="bg-white custom-calendar-clear"
                      @click="filters.dateRange = null">
                      Clear
                    </button>
                  </b-form-group>
                </b-col>
                <b-col lg="4" v-show="applianceFilter" class="my-1">
                  <b-form-group
                    :label="$t('Appliance No')"
                    label-for="appliance-input"
                  >
                    <b-form-input
                      min=0
                      id="appliance-input"
                      type="number"
                      v-model="filters.applianceNumber"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="4" v-show="applianceTypeFilter" class="my-1">
                  <b-form-group
                    :label="$t('Appliance Type')"
                    label-for="appliance-input"
                  >
                    <b-form-select
                      id="input-4"
                      size="sm"
                      v-model="filters.applianceType"
                      :options="applianceTypes"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col lg="4" v-show="applianceStatusFilter" class="my-1">
                  <b-form-group
                    :label="$t('Appliance Status')"
                    label-for="appliance-input"
                  >
                    <b-form-select
                      id="input-4"
                      size="sm"
                      v-model="filters.applianceStatus"
                      :options="applianceStatuses"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col lg="4" class="my-1">
                  <b-form-group
                    :label="$t('Keyword Search')"
                    label-for="appliance-input"
                  >
                  <b-form-input
                    v-model="filters.keyword"
                    type="search"
                    :placeholder="$t('Keyword Search')"
                  ></b-form-input>
                  </b-form-group>
                </b-col>
                  <b-col lg="8" class="my-1">

                    <b-btn style="float:right;color:white;margin-bottom: 15px; margin-top: 15px;" variant="light" @click="searchLabels(true)"><i class="fa fa-search"></i>{{$t('Search')}}</b-btn>
                  </b-col>
              </b-row>
              </div>
              <b-row>
                <b-col>
                  <h4 style="float:left;" class="pl-3 pt-3 print_hide">{{$t('Results')}}</h4>
                  <b-btn class="print_hide" v-show="labels.length > 0" style="float:right;color:white;margin-bottom: 10px;margin-top: 10px;margin-right: 10px" variant="light" @click="printLabels()"><i class="fa fa-print"></i> {{$t('Print Results')}}</b-btn>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <div class="print_results">
              <b-table
                :busy.sync="isBusy"
                tbody-class="asdfgh"
                show-empty
                hover
                outlined
                stacked="true"
                :items="labels"
                :fields="labelFields"
                :current-page="currentPage"
                :per-page="0"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
              >
                <template v-slot:empty="scope">
                  <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
                </template>

                <template v-slot:cell(userId)="row">
                  <b-link class="nav-link no-padding print_hide" :to="'/users/'+row.item.userId"> {{ row.item.userName }} </b-link>
                  <div class="print_show">{{row.item.userName}}</div>
                </template>
                <template v-slot:cell(applianceType)="row">
                   {{$t(row.item.applianceType)}}
                </template>
                <template v-slot:cell(applianceStatus)="row">
                   {{$t(row.item.applianceStatus)}}
                </template>
                <template v-slot:cell(dayOut)="row">
                  {{$t(row.item.dayOut)}}
                </template>
                <template v-slot:cell(allergenOptions)="row">
                  <template v-for="allergen in row.item.allergenOptions">
                    <span v-bind:key="allergen">{{ $t(allergen)}},  </span>
                  </template>
                </template>
                <template v-slot:cell(allergenCodes)="row">
                  <template v-for="allergen in row.item.allergenCodes">
                    <span v-bind:key="allergen">{{ $t(allergen)}}, </span>
                  </template>
                </template>
                <template v-slot:cell(dateInAndOut)="row">
                  <div v-if="filters.labelType === 'BLAST_CHILLER'">
                    {{ row.item.dateIn }}
                  </div>
                  <div v-else>
                    {{ row.item.datetimeIn }}
                  </div>
                </template>
                <template v-slot:cell(temperatureIn)="row">
                    {{ row.item.temperatureIn }}°C
                </template>
                <template v-slot:cell(temperatureOut)="row">
                  {{ row.item.temperatureOut }}°C
                </template>
                <template v-slot:cell(actions)="row" >
                  <b-button variant="outline-dark" size="sm">
                    {{$t('Demo')}}
                  </b-button>
                </template>
              </b-table>
              </div>
              <b-row>
                <b-col lg="12" class="my-1 print_hide text-center">
                  <b-btn v-show="loadMoreBool" style="margin-bottom: 20px" pill variant="outline-secondary" @click="loadMore">{{$t('Load More')}}</b-btn>
                </b-col>
              </b-row>

            </b-container>
          </b-tab>
          <b-tab :title="$t('Forms')" id="haccp">
                <b-tabs>
                  <b-tab :title="$t('Form Results')" id="formsResultsTable">
                    <b-table
                      show-empty
                      hover
                      stacked="true"
                      :items="users"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                    >
                      <template v-slot:empty="scope">
                        <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
                      </template>
                      <template v-slot:cell(name)="row">
                        <b-link class="nav-link no-padding" :to="'/users/'+row.item.id"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>
                      </template>

                      <template v-slot:cell(status)="row">
                        <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
                      </template>

                      <template v-slot:cell(actions)="row" >
                        <b-button variant="outline-dark" size="sm" @click="removeFromGroup(row.item.id)">
                          {{$t('Remove')}}
                        </b-button>
                      </template>
                    </b-table>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="center"
                      class="my-5"
                    ></b-pagination>
                  </b-tab>
                  <b-tab :title="$t('Forms')" @click="fetchForms" id="formsTable">
                    <div class="col-12 bg-white p-4 float-left">
                      <b-row>
                        <b-col>
                        <h4 class="pl-2">{{$t('Group Forms')}}</h4>
                        </b-col>
                        <b-col>
                          <b-btn style="float:right;color:white" variant="light" @click="getCompanyUsers" v-b-modal.modal-user-to-group>{{$t('Create Form')}}</b-btn>
                        </b-col>
                      </b-row>
                      <b-table
                      show-empty
                      hover
                      stacked="true"
                      :items="forms"
                      :fields="formFields"
                      :current-page="currentFormPage"
                      :per-page="perPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                    >
                      <template v-slot:empty="scope">
                        <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
                      </template>
                      <template v-slot:cell(name)="row">
                        <b-link class="nav-link no-padding" :to="'/forms/'+row.item.id"> {{ row.item.name }} </b-link>
                      </template>

                      <template v-slot:cell(status)="row">
                        <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
                      </template>

                      <template v-slot:cell(actions)="row" >
                        <b-button variant="outline-dark" size="sm" @click="removeFromGroup(row.item.id)">
                          {{$t('Remove')}}
                        </b-button>
                      </template>
                    </b-table>
                      <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="center"
                      class="my-5"
                    ></b-pagination>
                    </div>
                  </b-tab>
                </b-tabs>
          </b-tab>
          <b-tab :title="$t('Users')" id="users">
            <div class="col-12 bg-white p-4 float-left">
              <b-container fluid>
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-btn style="float:right;color:white" variant="light" @click="getCompanyUsers" v-b-modal.modal-user-to-group>{{$t('Add User to Group')}}</b-btn>
            </b-col>

          </b-row>
          <!-- Main table element -->
          <b-table
            show-empty
            hover
            stacked="true"
            :items="users"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:empty="scope">
              <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
            </template>
            <template v-slot:cell(name)="row">
              <b-link class="nav-link no-padding" :to="'/users/'+row.item.id"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>
            </template>

            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="outline-dark" size="sm" @click="removeFromGroup(row.item.id)">
                {{$t('Remove')}}
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
            </div>
          </b-tab>
        </b-tabs>
          <b-modal
          id="modal-user-to-group"
          ref="modal"
          :title="$t('Add new User to Group')"
          @show="resetModal"
          @hidden="resetModal"
          @ok="addUsertoGroup"
          okVariant="light"
          ok-title-html="<span style='color:white;'>Submit</span>"
          header-bg-variant="light"
          header-text-variant="white"
        >
          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group id="input-group-4" :label="$t('Select User')" label-for="input-4">
              <b-form-select
                id="input-4"
                size="sm"
                v-model="form.user"
                :options="companyUsers"
                :state="$v.form.user.$dirty ? !$v.form.user.$error : null"
              ></b-form-select>
              <b-form-invalid-feedback id="input-7-live-feedback">
                {{$t('This is a required field')}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
      </div>

</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      forms: [],
      currentFormPage: 1,
      labelTypes: [],
      loadMoreBool: false,
      startDateFormatted: null,
      endDateFormatted: null,
      isBusy: false,
      loading: false,
      groupId: this.$route.params.id,
      group: {name: null, category: null},
      users: [],
      companyUsers: [{text: this.$t('Select User'), value: ''}],
      fields: [
        { key: 'name', label: this.$t('Name'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' },

        {
          key: 'status',
          label: this.$t('Status'),
          // formatter: (value, key, item) => {
          //   return value ? 'Yes' : 'No'
          // },
          sortable: true,
          class: 'text-center'
          // sortByFormatted: true,
          // filterByFormatted: true
        },
        { key: 'actions', label: this.$t('Actions'), class: 'text-center' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      form: {
        companyId: null,
        groupId: this.$route.params.id,
        user: ''
      },
      labels: [],
      selectedLabelType: null,
      usersOptions: [
        {
          groupName: this.$t('Select All'),
          users: []
        }
      ],
      lastVisible: null,
      filters: {
        dateRange: null,
        users: [],
        labelType: null,
        applianceNumber: null,
        applianceType: null,
        applianceStatus: null,
        keyword: null
      },
      applianceFilter: false,
      applianceTypeFilter: false,
      applianceStatusFilter: false,
      applianceStatuses: [{text: this.$t('Select Status'), value: null}, {text: this.$t('UNDER_MAINTENANCE'), value: 'UNDER_MAINTENANCE'}, {text: this.$t('WORKING'), value: 'WORKING'}],
      applianceTypes: [{text: this.$t('Select Type'), value: null}, {text: this.$t('FREEZER'), value: 'FREEZER'}, {text: this.$t('FRIDGE'), value: 'FRIDGE'}]
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    // labelTypes () {
    //   return [
    //     { value: 'LABELLING', text: this.$t('LABELLING') },
    //     { value: 'TEMPERATURE', text: this.$t('TEMPERATURE') },
    //     { value: 'BLAST_CHILLER', text: this.$t('BLAST_CHILLER') },
    //     { value: 'ALLERGEN', text: this.$t('ALLERGEN') },
    //     { value: 'INGREDIENTS', text: this.$t('INGREDIENTS') },
    //     { value: 'FREE_NOTES', text: this.$t('FREE_NOTES') },
    //     { value: 'USE_FIRST', text: this.$t('USE_FIRST') }
    //   ]
    // },
    formFields () {
      var aFields = []
      aFields.push({ key: 'name', label: this.$t('Title'), sortable: true })
      aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      return aFields
    },
    labelFields () {
      var self = this
      var aFields = []
      aFields.push({ key: 'userId', label: this.$t('User'), sortable: true, class: 'text-center' })
      switch (this.filters.labelType) {
        case 'LABELLING':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'dateIn', label: this.$t('Prep Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Expiry Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dayOut', label: this.$t('Expiry Day'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'TEMPERATURE':
          // fields
          aFields.push({ key: 'title', label: this.$t('Appliance Title'), sortable: true })
          aFields.push({ key: 'applianceType', label: this.$t('Appliance Type'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'applianceNumber', label: this.$t('Number'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'applianceStatus', label: this.$t('Appliance Status'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'temperatureIn', label: this.$t('Temperature'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Date/Time'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = true
          self.applianceTypeFilter = true
          self.applianceStatusFilter = true
          break
        case 'BLAST_CHILLER':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'temperatureIn', label: this.$t('Temperature In'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'temperatureOut', label: this.$t('Temperature Out'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Date/Time In'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Date/Time Out'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'ALLERGEN':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'allergenOptions', label: this.$t('Allergen Options'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'allergenCodes', label: this.$t('Allergens'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Production Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Expiry Date'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'INGREDIENTS':
          aFields.push({ key: 'title', label: this.$t('Product'), sortable: true })
          aFields.push({ key: 'ingredients', label: this.$t('Ingredients'), sortable: false })
          aFields.push({ key: 'allergenOptions', label: this.$t('Allergen Options'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'allergenCodes', label: this.$t('Allergens'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateIn', label: this.$t('Production Date'), sortable: true, class: 'text-center' })
          aFields.push({ key: 'dateOut', label: this.$t('Expiry Date'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'FREE_NOTES':
          aFields.push({ key: 'title', label: this.$t('Text'), sortable: true, class: 'text-left' })
          aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
        case 'USE_FIRST':
          aFields.push({ key: 'title', label: this.$t('Name'), sortable: true, class: 'text-left' })
          aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })

          // filters
          self.applianceFilter = false
          self.applianceTypeFilter = false
          self.applianceStatusFilter = false
          break
      }
      aFields.push({ key: 'numberOfCopies', label: this.$t('Copies'), sortable: true, class: 'text-center' })
      // aFields.push({ key: 'status', label: this.$t('Status'), sortable: true })
      if (this.$store.state.user.data.role === 'System Admin') {
        // aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      }
      return aFields
    }
  },
  validations: {
    form: {
      user: {
        required
      }
    },
    filters: {
      labelType: {
        required
      }
    }
  },
  mounted () {
    if (this.$route.params.company) {
      this.form.companyId = this.$route.params.company
    } else {
      this.form.companyId = this.$store.state.user.data.companyId
    }

    this.fetchGroup()
    // Set the initial number of items
    this.totalRows = this.groups

    this.fetchLabelTypes()
  },
  methods: {
    fetchForms () {
      var self = this
      this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').doc(this.$route.params.id).collection('forms').get().then(function (forms) {
        forms.forEach(function (form) {
          console.log('form', form.data())
          var formData = form.data()
          formData.id = form.id
          if (formData.createdAt != null) {
            formData.createdAt = moment(String(formData.createdAt.toDate())).format('DD/MM/YYYY hh:mm')
          }
          self.forms.push(formData)
        })
      })
    },
    fetchLabelTypes () {
      var self = this
      let labels = [
        { value: 'LABELLING', text: self.$t('LABELLING') },
        { value: 'TEMPERATURE', text: self.$t('TEMPERATURE') },
        { value: 'BLAST_CHILLER', text: self.$t('BLAST_CHILLER') },
        { value: 'ALLERGEN', text: self.$t('ALLERGEN') },
        { value: 'INGREDIENTS', text: self.$t('INGREDIENTS') },
        { value: 'FREE_NOTES', text: self.$t('FREE_NOTES') },
        { value: 'USE_FIRST', text: self.$t('USE_FIRST') }]

      this.$firebase.firestore().doc('companies/' + this.form.companyId + '/settings/preferences').get().then(function (doc) {
        var preferences = doc.data()
        if (preferences) {
          if (preferences.hasOwnProperty('labelTypes')) {
            labels.forEach(type => {
              console.log('type', type)
              var index = preferences.labelTypes.findIndex(t => t === type.value)
              console.log('index', index)
              if (index !== -1) {
                var lType = preferences.labelTypes[index]
                self.labelTypes.push({value: lType, text: self.$t(lType)})
              }
            })
            //
            // preferences.labelTypes.forEach(type => {
            //   self.labelTypes.push({value: type, text: self.$t(type)})
            // })
          }
        } else {
          self.labelTypes = labels
        }
      })
    },
    clearResults () {
      this.filters.applianceType = null
      this.filters.applianceStatus = null
      this.filters.applianceNumber = null
      this.labels = []
    },
    searchLabels (clear) {
      var self = this
      var data = {}

      this.$v.filters.$touch()
      if (this.$v.filters.$anyError) {
        return
      }

      this.loadMoreBool = true
      if (clear) {
        this.labels = []
        this.lastVisible = null
      }
      if (this.lastVisible) {
        data.lastVisible = this.lastVisible
      }

      // for printing purposes
      if (this.filters.dateRange != null) {
        this.startDateFormatted = moment(new Date(this.filters.dateRange.start).toString()).format('DD/MM/YYYY')
      } else {
        this.startDateFormatted = null
      }
      if (this.filters.dateRange != null) {
        this.endDateFormatted = moment(new Date(this.filters.dateRange.end).toString()).format('DD/MM/YYYY')
      } else {
        this.endDateFormatted = null
      }

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = this.filters
      this.$store.dispatch('searchLabels', data).then(resp => {
        if (resp.lastVisible != null) {
          self.lastVisible = resp.lastVisible
        }
        resp.labels.forEach(label => {
          var user = self.users.find(u => u.id === label.userId)
          if (user) {
            label.userName = user.firstName + ' ' + user.lastName
          }
          self.labels.push(label)
        })
      })
    },
    loadMore () {
      this.searchLabels(false)
    },
    removeFromGroup (userId) {
      let self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to remove this User from the Group.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {
          if (value) {
            this.loading = true
            var data = {
              userId: userId,
              companyId: self.$route.params.hasOwnProperty('company') ? self.$route.params.company : self.$store.state.user.data.companyId,
              groupId: self.$route.params.id
            }
            const removeUserFromGroup = this.$firebase.functions().httpsCallable('removeUserFromGroup')
            removeUserFromGroup(data).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.$swal({
                  title: self.$t('User Removed from Group!'),
                  type: 'success',
                  timer: 1000,
                  showConfirmButton: false
                }).then(function (result) {
                  let index = self.users.findIndex(u => u.id === userId)
                  if (index > -1) {
                    self.users.splice(index, 1)
                  }
                  self.fetchGroup(true)
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    getCompanyUsers () {
      var self = this
      this.$firebase.firestore().collection('users').where('companyId', '==', this.form.companyId).orderBy('firstName').get().then(function (users) {
        self.companyUsers = [{text: self.$t('Select User'), value: ''}]
        users.forEach(function (user) {
          // console.log('user', user.data().firstName)
          var userData = user.data()
          if (!self.group.users.includes(user.id)) {
            var name = userData.firstName + ' ' + userData.lastName
            self.companyUsers.push({value: user.id, text: self.$t(userData.role == null ? 'User' : userData.role) + ' - ' + name})
          }
        })
      })
    },
    fetchGroup (bypass = false) {
      let self = this
      if (self.group.name === null || bypass) {
        var group = this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').doc(this.$route.params.id)
        group.get().then(function (querySnapshot) {
          var groupData = querySnapshot.data()
          self.group = groupData
          self.usersOptions[0].users = []
          groupData.users.forEach(function (userId) {
            self.$firebase.firestore().collection('users').doc(userId).get().then(function (user) {
              var userData = user.data()
              userData.id = user.id

              // preare user select options
              self.usersOptions[0].users.push({text: userData.firstName + ' ' + userData.lastName, value: user.id})

              if (groupData.createdAt != null) {
                userData.createdAt = moment(String(userData.createdAt.toDate())).format('DD/MM/YYYY')
              }
              let index = self.users.findIndex(m => m.id === userData.id)
              if (index > -1) {
                self.users[index] = userData
              } else {
                self.users.push(userData)
              }
            })
          })
        })
      }
    },
    resetModal () {
      this.form.user = ''
      this.$v.$reset()
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    addUsertoGroup (e) {
      e.preventDefault()

      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.loading = true
      let self = this

      const addUser = this.$firebase.functions().httpsCallable('addUsertoGroup')
      addUser(this.form).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('User added to Group!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.fetchGroup(true)
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    printLabels () {
      print()
    }
  }
}
</script>
<style>
  .btn-group-toggle.btn-group {
    width: 100%;
  }
  .multiselect__tags {
    min-height: unset;
    padding: 4px 40px 3px 8px;
    border-radius: 0;
  }
  span.multiselect__placeholder {
    margin-bottom: 0;
  }
  label.btn.btn-white {
    background-color: white;
    border-right: 2px solid #eff8ff;
    border-left: 2px solid #eff8ff;
  }

  label.btn.btn-white.active {
    background-color: #c8e9f8;
  }

  #haccp ul.nav-tabs {
    background: #c8e9f8;
  }

  .print_show{
    display: none;
  }
  @media print {

    @page {
      margin: 1cm;
      margin-bottom: 5cm;
    }
    /*.print_results{*/
      /*width: 100%;*/
      /*position: fixed;*/
      /*top: 0;*/
      /*left: 0;*/
      /*z-index: 1000000;*/
      /*background: white;*/
      /*height: 100%;*/
    /*}*/

    footer {
      position: fixed;
      bottom: 0;
      height: 100px;
      background: #000;
    }

    body {
      margin: 0 0 0 0;
    }
    a {
      color: #00aeef;
      text-decoration: none;
    }
    .print_show{
      display: block;
    }
    .print_hide{
      display: none;
    }
    .navbar.fixed-top+.page-body-wrapper {
      background-color: transparent;
    }
    .tabs ul {
      display: none;
    }

    .main-panel {
      margin: 0;
      width: 100%;
    }
    .content-wrapper {
      padding: 0;
      background: transparent;
    }
    .print_title{
      width: 100%;
      text-align: center;
    }

    /*html, body {*/
      /*!*height:100vh;*!*/
      /*margin: 0 !important;*/
      /*padding: 0 !important;*/
      /*overflow: hidden;*/
    /*}*/

  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue